module.exports = __webpack_public_path__ + "media/images/meta/purebarre/apple-touch-icon-0e69269469e8d8cfbcc67f42c9051db5.png";